import { z } from 'zod';

import { GlobalResponseSchema } from './global-schema';

export const UserMenuSchema = z.union([
  z.object({
    id: z.number(),
    title: z.string(),
    route: z.string().nullable(),
    icon: z.string().nullable(),
    parent_menu_id: z.null(),
    orders: z.number(),
    is_menu: z.boolean(),
    created: z.string(),
  }),
  z.object({
    id: z.number(),
    title: z.string(),
    route: z.null(),
    icon: z.string().nullable(),
    parent_menu_id: z.null(),
    orders: z.number(),
    is_menu: z.boolean(),
    created: z.string(),
    items: z.array(
      z.object({
        id: z.number(),
        title: z.string(),
        route: z.string().nullable(),
        icon: z.null(),
        parent_menu_id: z.number(),
        orders: z.number(),
        is_menu: z.boolean(),
        created: z.string(),
      }),
    ),
  }),
  z.object({
    id: z.number(),
    title: z.string(),
    route: z.string(),
    icon: z.null(),
    parent_menu_id: z.null(),
    orders: z.number(),
    is_menu: z.boolean(),
    created: z.string(),
  }),
]);
export const UserMenusResponse = GlobalResponseSchema.extend({
  data: z.object({
    menus: z.array(UserMenuSchema),
    user_permissions: z.array(z.string()),
  }),
});
